import { Link } from "react-router-dom";

export default function IndexBrands() {
  return (
    <>
      <h3>Brands</h3>
      <Link className="btn btn-primary" to="/brands/create">
        Create Brand{" "}
      </Link>
    </>
  );
}
